"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconWrapper = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layout = require("../layout");

var _icons = require("../icons");

var _text = require("../text");

var _button = require("../button");

var _core = require("@emotion/core");

var IconWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e13b1chk0"
})("transition:transform 200ms;transform:", function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'rotate(180deg)' : 'rotate(0)';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BvcG92ZXItbGVnYWN5L1RyaWdnZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU3dDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3BvcG92ZXItbGVnYWN5L1RyaWdnZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgU3BhY2VyIH0gZnJvbSAnLi4vbGF5b3V0JztcbmltcG9ydCB7IEljb25DaGV2cm9uRG93biB9IGZyb20gJy4uL2ljb25zJztcbmltcG9ydCB7IFRleHQgfSBmcm9tICcuLi90ZXh0JztcbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJy4uL2J1dHRvbic7XG5cbmV4cG9ydCBjb25zdCBJY29uV3JhcHBlciA9IHN0eWxlZCgnZGl2JylgXG4gIHRyYW5zaXRpb246IHRyYW5zZm9ybSAyMDBtcztcbiAgdHJhbnNmb3JtOiAkeyh7IGlzT3BlbiB9KSA9PiAoaXNPcGVuID8gJ3JvdGF0ZSgxODBkZWcpJyA6ICdyb3RhdGUoMCknKX07XG5gO1xuXG5JY29uV3JhcHBlci5kaXNwbGF5TmFtZSA9ICdJY29uV3JhcHBlcic7XG5JY29uV3JhcHBlci5wcm9wVHlwZXMgPSB7XG4gIGlzT3BlbjogUHJvcFR5cGVzLmJvb2wuaXNSZXF1aXJlZFxufTtcblxuY29uc3QgVHJpZ2dlciA9ICh7XG4gIGlzT3BlbixcbiAgY2hpbGRyZW4sXG4gIG9uQ2xpY2ssXG4gICdhcmlhLWhhc3BvcHVwJzogYXJpYUhhc1BvcHVwXG59KSA9PiAoXG4gIDxCdXR0b25cbiAgICBkYXRhLXRlc3QtY29tcG9uZW50PVwiUG9wb3ZlclRyaWdnZXJcIlxuICAgIGFyaWEtZXhwYW5kZWQ9e2lzT3Blbn1cbiAgICBhcmlhLWhhc3BvcHVwPXthcmlhSGFzUG9wdXB9XG4gICAgYXJpYS1jb250cm9scz17J3BvcG92ZXJDb250ZW50J31cbiAgICB0ZXJ0aWFyeVxuICAgIGhhc0ljb25cbiAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgIGFsaWduSXRlbXM9XCJjZW50ZXJcIj5cbiAgICA8VGV4dCBmb250U2l6ZT1cIlQyMDBcIiBmb250V2VpZ2h0PVwibWVkaXVtXCI+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9UZXh0PlxuICAgIDxTcGFjZXIgd2lkdGg9ezR9IC8+XG4gICAgPEljb25XcmFwcGVyIGlzT3Blbj17aXNPcGVufT5cbiAgICAgIDxJY29uQ2hldnJvbkRvd24gYXJpYS1oaWRkZW49e3RydWV9IC8+XG4gICAgPC9JY29uV3JhcHBlcj5cbiAgPC9CdXR0b24+XG4pO1xuXG5UcmlnZ2VyLnByb3BUeXBlcyA9IHtcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLFxuICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbiAgaXNPcGVuOiBQcm9wVHlwZXMuYm9vbCxcbiAgJ2FyaWEtaGFzcG9wdXAnOiBQcm9wVHlwZXMuc3RyaW5nXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUcmlnZ2VyO1xuIl19 */"));
exports.IconWrapper = IconWrapper;
IconWrapper.displayName = 'IconWrapper';
IconWrapper.propTypes = {
  isOpen: _propTypes.default.bool.isRequired
};

var Trigger = function Trigger(_ref2) {
  var isOpen = _ref2.isOpen,
      children = _ref2.children,
      onClick = _ref2.onClick,
      ariaHasPopup = _ref2['aria-haspopup'];
  return (0, _core.jsx)(_button.Button, {
    "data-test-component": "PopoverTrigger",
    "aria-expanded": isOpen,
    "aria-haspopup": ariaHasPopup,
    "aria-controls": 'popoverContent',
    tertiary: true,
    hasIcon: true,
    onClick: onClick,
    alignItems: "center"
  }, (0, _core.jsx)(_text.Text, {
    fontSize: "T200",
    fontWeight: "medium"
  }, children), (0, _core.jsx)(_layout.Spacer, {
    width: 4
  }), (0, _core.jsx)(IconWrapper, {
    isOpen: isOpen
  }, (0, _core.jsx)(_icons.IconChevronDown, {
    "aria-hidden": true
  })));
};

Trigger.propTypes = {
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  isOpen: _propTypes.default.bool,
  'aria-haspopup': _propTypes.default.string
};
var _default = Trigger;
exports.default = _default;